import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CheckMarkIcon = createIcon({
  displayName: 'CheckMarkIcon',
  path: (
    <path
      d='m4.407 13.34 4.182 4.247a1.37 1.37 0 0 0 1.962 0l9.042-9.182c.543-.551.543-1.44 0-1.992a1.37 1.37 0 0 0-1.961 0l-8.055 8.18-3.209-3.245a1.37 1.37 0 0 0-1.961 0 1.422 1.422 0 0 0 0 1.992Z'
      fill={'currentColor'}
    />
  ),
  defaultProps: defaultProps
})
